var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDeleteCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1878_21712)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.3 18C35.3 27.5545 27.5545 35.3 18 35.3C8.44547 35.3 0.7 27.5545 0.7 18C0.7 8.44547 8.44547 0.7 18 0.7C27.5545 0.7 35.3 8.44547 35.3 18Z",
    stroke: "#A1B9ED",
    strokeWidth: 1.4
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.2973 14.384L23.0267 27.1845C22.9543 27.9144 22.3986 28.4998 21.6651 28.4998H12.9933C12.2598 28.4998 11.7042 27.9147 11.6317 27.1845L10.3611 14.384H24.2973ZM14.3109 16.912C14.2905 16.5374 14.5794 16.2152 14.954 16.1948C15.3287 16.1743 15.6509 16.4632 15.6713 16.8379C15.8176 19.5216 15.964 22.2053 16.1102 24.8891C16.126 25.179 15.9676 25.4354 15.7013 25.551C15.4349 25.6666 15.1394 25.6073 14.9384 25.3977C14.8295 25.2842 14.7591 25.1328 14.7499 24.964C14.6035 22.2801 14.4572 19.596 14.3109 16.912ZM19.7045 16.1948C20.0775 16.2151 20.3679 16.539 20.3476 16.912C20.2013 19.5957 20.055 22.2795 19.9087 24.9632C19.8929 25.2531 19.7077 25.4906 19.4305 25.5767C19.1533 25.6628 18.8662 25.5719 18.689 25.342C18.5928 25.2172 18.539 25.0589 18.5482 24.8899C18.6945 22.2059 18.8408 19.5219 18.9872 16.8379C19.0076 16.4632 19.3298 16.1743 19.7045 16.1948Z",
    fill: "#DA293E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4607 11.5222H10.1974C9.5361 11.5222 9 12.0583 9 12.7196V12.7198C9 13.3811 9.5361 13.9172 10.1974 13.9172H24.4607C25.122 13.9172 25.6581 13.3811 25.6581 12.7198V12.7196C25.6581 12.0583 25.122 11.5222 24.4607 11.5222Z",
    fill: "#DA293E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.468 11.6392H20.2758V10.1073C20.2758 9.32895 19.639 8.69213 18.8607 8.69213H15.7983C15.02 8.69213 14.3831 9.32897 14.3831 10.1073V11.6392H13.191V10.1073C13.191 8.67098 14.362 7.5 15.7983 7.5H18.8607C20.297 7.5 21.468 8.671 21.468 10.1073V11.6392Z",
    fill: "#DA293E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1878_21712"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDeleteCircle);
export default __webpack_public_path__ + "static/media/IconDeleteCircle.84e45390ea0cf4f2f14ce6d756cb1d0a.svg";
export { ForwardRef as ReactComponent };